<script setup lang="ts">
defineProps({
  tag: {
    type: String,
    required: true,
    validator: (tag: string): boolean =>
      ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span'].includes(tag),
  },
  hide: {
    type: Boolean,
    default: true,
  },
});
</script>

<template>
  <component
    :is="tag"
    class="title"
    :class="{
      hide: hide,
    }"
  >
    <slot />
  </component>
</template>

<style scoped>
.title {
  @apply w-full break-words;
}

.hide {
  @apply overflow-hidden;

  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
  hyphens: auto;
}
</style>
